"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const o=require("react"),f=require("./node_modules/rc-util/lib/warning.js"),u=require("./node_modules/rc-util/lib/Dom/dynamicCSS.js"),m=require("./components/Context.js"),d=e=>e&&typeof e=="object"&&"default"in e?e:{default:e},c=d(o);function g(e,n){f(e,`[@pf-ui/pf-icons-react] ${n}`)}function p(e){return typeof e=="object"&&typeof e.name=="string"&&typeof e.theme=="string"&&(typeof e.icon=="object"||typeof e.icon=="function")}function a(e={}){return Object.keys(e).reduce((n,t)=>{const i=e[t];switch(t){case"class":n.className=i,delete n.class;break;default:n[t]=i}return n},{})}function s(e,n,t){return t?c.default.createElement(e.tag,{key:n,...a(e.attrs),...t},(e.children||[]).map((i,r)=>s(i,`${n}-${e.tag}-${r}`))):c.default.createElement(e.tag,{key:n,...a(e.attrs)},(e.children||[]).map((i,r)=>s(i,`${n}-${e.tag}-${r}`)))}function b(e){return e?Array.isArray(e)?e:[e]:[]}const y={width:"1em",height:"1em",fill:"currentColor","aria-hidden":"true",focusable:"false"},l=`
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`,h=(e=l)=>{const{csp:n}=o.useContext(m);o.useEffect(()=>{u.updateCSS(e,"@pf-ui/pf-icons-react",{prepend:!0,csp:n})},[])};exports.generate=s;exports.iconStyles=l;exports.isIconDefinition=p;exports.normalizeAttrs=a;exports.normalizeTwoToneColors=b;exports.svgBaseProps=y;exports.useInsertStyles=h;exports.warning=g;
